import { useLabVendors, type LabVendor } from '@/billing/services/use-lab-vendors';

/**
 * Lab vendor options for the lab desk filter (PROD-2653), from the PROD-2652
 * lab vendors hook: this organization's vendors, inactive ones included
 * (older requests were sent to them).
 */
export const LAB_DESK_VENDOR_PARAMS = {
  includeInactive: true,
  includeGlobal: false,
  skip: 0,
  take: 200,
} as const;

/** Option and chip label: inactive vendors read "Name (inactive)". */
export function labVendorOptionLabel(v: Pick<LabVendor, 'name' | 'isActive'>): string {
  return v.isActive ? v.name : `${v.name} (inactive)`;
}

/** Empty while loading or on error (a 503 before the LabVendor table exists),
 *  so the filter just offers "All vendors". */
export function useLabDeskVendors(): LabVendor[] {
  const { data } = useLabVendors(LAB_DESK_VENDOR_PARAMS);
  return data?.items ?? [];
}
